import { render, staticRenderFns } from "./AILoader.vue?vue&type=template&id=20c90026&scoped=true&"
import script from "./AILoader.vue?vue&type=script&lang=js&"
export * from "./AILoader.vue?vue&type=script&lang=js&"
import style0 from "./AILoader.vue?vue&type=style&index=0&id=20c90026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c90026",
  null
  
)

export default component.exports